import React from 'react';
import { useTranslation } from 'react-i18next';

import { useUpdateUserMutation } from '@/api/hooks/useUser';

import { Typography } from '@/components/atoms/Typography';
import { TextInput } from '@/components/forms/base/TextInput';
import { Form } from '@/components/forms/core/Form';
import { Button } from '@/components/molecules/Button';

import { ProfileSchema, ProfileSchemaType } from './schema';

export interface ProfileFormProps {
  onSuccess?: (data: any) => void;
}

export const ProfileForm = ({ onSuccess }: ProfileFormProps) => {
  const { t } = useTranslation();

  const updateUserMutation = useUpdateUserMutation({
    onSuccess
  });

  const handleSubmit = (data: ProfileSchemaType) => {
    updateUserMutation.mutate(data);
  };

  return (
    <div className="gap-4 flex flex-col w-full">
      <Typography variant="h3" weight="bold">
        {t('form.profileFormTitle')}
      </Typography>
      <Form
        data-testid="profile-form"
        schema={ProfileSchema}
        onSubmit={handleSubmit}
        className="flex flex-col gap-5"
        render={({ formState }) => (
          <>
            <TextInput id="lastName" label={t('form.lastName')} placeholder={t('form.lastNamePlaceholder')} required />
            <TextInput id="firstName" label={t('form.firstName')} placeholder={t('form.firstNamePlaceholder')} required />
            <TextInput id="email" label={t('form.emailAddress')} placeholder={t('form.emailAddressPlaceholder')} required />
            <TextInput id="phoneNumber" label={t('form.phoneNumber')} placeholder={t('form.phoneNumberPlaceholder')} required />
            <div>
              <Button
                type="submit"
                color="primary"
                label={t('form.save')}
                loading={updateUserMutation.isLoading}
                disabled={!formState.isDirty || updateUserMutation.isLoading}
              />
            </div>
          </>
        )}
      />
    </div>
  );
};
